import './footer.css'
import { useI18n } from '../lib/i18n'
import { Reveal } from '../components/Reveal'
import { Wordmark } from '../components/Wordmark'

export default function Footer() {
  const { lang } = useI18n()
  const C = (
    {
      vi: {
        tagline: 'Tuân thủ EUDR cho cà phê Việt Nam — mỗi lô, một bằng chứng.',
        productTitle: 'Sản phẩm',
        learnTitle: 'Tìm hiểu',
        product: [
          { label: 'Lot Passport', href: '/app' },
          { label: 'EUDR Ready Pack', href: '/app' },
          { label: 'Live Monitoring', href: '/app' },
          { label: 'Vào hệ thống', href: '/app' },
        ],
        learn: [
          { label: 'Vấn đề', href: '#problem' },
          { label: 'Quy trình', href: '#how' },
          { label: 'Tin tức', href: '#news' },
          { label: 'Về ARGO', href: '#about' },
          { label: 'Liên hệ', href: 'mailto:kiet922006@gmail.com' },
        ],
        copyright: '© 2026 ARGO.',
        disclaimer:
          'ARGO cung cấp dữ liệu đầu vào cho DDS. Nhà nhập khẩu EU nộp qua TRACES NT.',
      },
      en: {
        tagline: 'EUDR compliance for Vietnamese coffee — every lot, one proof.',
        productTitle: 'Product',
        learnTitle: 'Learn',
        product: [
          { label: 'Lot Passport', href: '/app' },
          { label: 'EUDR Ready Pack', href: '/app' },
          { label: 'Live Monitoring', href: '/app' },
          { label: 'Enter the system', href: '/app' },
        ],
        learn: [
          { label: 'The problem', href: '#problem' },
          { label: 'How it works', href: '#how' },
          { label: 'News', href: '#news' },
          { label: 'About ARGO', href: '#about' },
          { label: 'Contact', href: 'mailto:kiet922006@gmail.com' },
        ],
        copyright: '© 2026 ARGO.',
        disclaimer:
          'ARGO provides input data for the DDS. EU importers submit it via TRACES NT.',
      },
    } as const
  )[lang]

  return (
    <footer className="footer">
      <div className="container">
        <Reveal y={20}>
          <div className="footer-top">
            <div className="footer-brand">
              <Wordmark size={26} />
              <p className="footer-tagline">{C.tagline}</p>
            </div>

            <nav className="footer-cols" aria-label={lang === 'vi' ? 'Liên kết chân trang' : 'Footer links'}>
              <div className="footer-col">
                <h3 className="footer-col-title label">{C.productTitle}</h3>
                <ul className="footer-list">
                  {C.product.map((l) => (
                    <li key={l.label}>
                      <a className="footer-link" href={l.href}>
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="footer-col">
                <h3 className="footer-col-title label">{C.learnTitle}</h3>
                <ul className="footer-list">
                  {C.learn.map((l) => (
                    <li key={l.label}>
                      <a className="footer-link" href={l.href}>
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </nav>
          </div>
        </Reveal>

        <div className="footer-bot">
          <span className="footer-copy">{C.copyright}</span>
          <span className="footer-disclaimer">{C.disclaimer}</span>
        </div>
      </div>
    </footer>
  )
}
